import type { CombinedWarehouseOrderItemDto } from "@lib/ShiOneClient";
import { parseScopedRouteId, toScopedRouteId } from "./orderRouteKey";

type IntegrationTransferTicketKey = Pick<
  CombinedWarehouseOrderItemDto,
  "salesId" | "uniqueIdentifier"
>;

/** Builds the URL id of the integration transfer drawer, `{salesId}~{uniqueIdentifier}`. */
export function toIntegrationTransferRouteId(
  ticket: IntegrationTransferTicketKey,
): string | undefined {
  return toScopedRouteId(
    ticket.salesId?.trim(),
    ticket.uniqueIdentifier?.trim(),
  );
}

/** Reverses `toIntegrationTransferRouteId`. */
export function parseIntegrationTransferRouteId(
  routeId: string,
): { salesId: string; uniqueIdentifier: string } | undefined {
  const parts = parseScopedRouteId(routeId);
  return parts
    ? { salesId: parts.scope, uniqueIdentifier: parts.id }
    : undefined;
}

/** Whether a ticket is the one a parsed route id names, using the builder's trimming. */
export function matchesIntegrationTransferRouteId(
  ticket: IntegrationTransferTicketKey,
  target: { salesId: string; uniqueIdentifier: string },
): boolean {
  return (
    ticket.salesId?.trim() === target.salesId &&
    ticket.uniqueIdentifier?.trim() === target.uniqueIdentifier
  );
}
